import { render } from "./TiptapComponent.vue?vue&type=template&id=33780eb2&scoped=true"
import script from "./TiptapComponent.vue?vue&type=script&lang=js"
export * from "./TiptapComponent.vue?vue&type=script&lang=js"

import "./TiptapComponent.vue?vue&type=style&index=0&id=33780eb2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33780eb2"]])

export default __exports__